import '@fontsource/raleway/300.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './components/App';
import { loadFrontEndIntegrations } from './fe-plugins';
import './i18n';
import './index.css';

if (process.env.NODE_ENV === 'development') {
	if (module.hot) module.hot.accept();
}

loadFrontEndIntegrations(window.document);

render(<App />, document.getElementById('app'));
